<template>
    <v-card-text :class="`${secondColor}--text pb-0`" v-if="visible">
        <div :class="['tolerance-box', { 'expired': expired }]">
            <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center font-weight-bold">
                    <v-icon small :color="secondColor" class="mr-1">alarm</v-icon>
                    {{ expired ? "Cobrança de ociosidade ativa" : "Tolerância para retirar o veículo" }}
                </div>
                <strong class="text-no-wrap ml-2" v-if="!expired">{{ remaining }} min</strong>
            </div>
            <v-progress-linear v-if="!expired" class="mt-2" :value="remainingPercent" :color="secondColor" background-opacity="0.25" height="6" rounded />
        </div>
    </v-card-text>
</template>

<script>
// Tolerância e minutos ociosos já calculados pela API (plug.partialValue.idle), com a mesma regra usada na cobrança
export default {
    props: {
        plug: {
            required: true,
        },
        secondColor: {
            required: true,
        },
    },

    computed: {
        idle() {
            return this.plug.partialValue ? this.plug.partialValue.idle : null;
        },
        visible() {
            return this.plug.unlockBy == "PAY" && !!this.idle && this.idle.price > 0 && this.idle.tolerance > 0 && this.plug.status == "Finishing";
        },
        expired() {
            return this.idle.toleranceExpired;
        },
        remaining() {
            return this.idle.toleranceRemaining;
        },
        remainingPercent() {
            return (this.remaining / (this.idle.tolerance + 1)) * 100;
        },
    },
}
</script>

<style scoped>
.tolerance-box {
    border: 1px solid currentColor;
    border-radius: 12px;
    padding: 10px 12px;
}

.tolerance-box.expired {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
    50% {
        opacity: 0.5;
    }
}
</style>
